import { useEffect, useState } from 'react';

interface DraftToastProps {
  visible: boolean;
  onHide: () => void;
}

const DraftToast = ({ visible, onHide }: DraftToastProps) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (visible) {
      setShow(true);
      const t = setTimeout(() => {
        setShow(false);
        onHide();
      }, 2500);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [visible, onHide]);

  if (!show) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2.5 bg-stone-800 text-white text-xs font-medium px-4 py-3 rounded-full whitespace-nowrap"
      style={{ animation: 'fadeSlideUp 0.3s ease' }}
    >
      <i className="ri-save-3-line text-emerald-400 text-sm"></i>
      تم حفظ المسودة تلقائياً
    </div>
  );
};

export default DraftToast;
